<div *ngIf="checkValid()" class="profit-calc">
  <table [ngClass]="print ? 'payment-table' : 'payment-table-screen'">
    <thead>
      <tr>
        <th *ngIf="!print && !disabled" [ngStyle]="print && { width: 0 }"><button class="nrk-doc-button" (click)="addItem()">+</button></th>
        <th>Pos</th>
        <th [ngStyle]="{ 'background-color': totalPercent() !== 100 && !print ? 'red' : 'unset' }">{{totalPercent() !== 100 && !print ? totalPercent() : ''}}%</th>
        <th>Payment Schedule / Schedule Details</th>
        <th>Terms of Payment</th>
        <th>Period of Payment</th>
        <th *ngIf="!print || profitMargin">IN</th>
        <th *ngIf="profitMargin" style="font-size:large">¤</th>
        <th *ngIf="profitMargin">Status</th>
        <th *ngIf="profitMargin">Expected Invoice Date</th>
        <!-- <th>Invoice #</th>
        <th>Paid</th> -->
      </tr>
    </thead>
    <ng-container *ngIf="compilation.paymentPlan && !print">
      <tbody *ngFor="let item of compilation.paymentPlan.items; index as idx; first as first; last as last">
        <tr>
          <td *ngIf="!disabled">
            <button class="nrk-doc-button" (click)="removeItem(idx)">-</button>
            <div *ngIf="!first" [ngStyle]="{cursor: 'pointer'}" (click)="movePaymentUp(idx)">▲</div>
            <div *ngIf="!last" [ngStyle]="{cursor: 'pointer'}" (click)="movePaymentDown(idx)">▼</div>
          </td>
          <td>{{idx + 1 | nrkPad : 2}}</td>
          <td><ngx-doc-form-texfield class="fullwidth" placeholder="Percent" [(value)]="item.percent" [disabled]="disabled"></ngx-doc-form-texfield></td>
          <td style="width:20rem">
            <ngx-doc-form-filter-select [(value)]="item.textPrefix" [options]="data.paymentPlanTextOptions"></ngx-doc-form-filter-select>
            <ngx-form-text [multiline]="1" [(value)]="item.textPrefix"></ngx-form-text>
          </td>
          <!-- <td><ngx-doc-store-dropdown [(value)]="item.text" store="paymentTextStore" placeholder="Select payment text" [disabled]="disabled"></ngx-doc-store-dropdown></td> -->
          <td>
            <ngx-doc-form-filter-select [(value)]="item.text" [options]="data.paymentTextOptions"></ngx-doc-form-filter-select>
            <ngx-form-text [multiline]="1" [(value)]="item.text"></ngx-form-text>
          </td>
          <!-- <td><ngx-doc-store-dropdown [(value)]="item.termsOfPayment" store="termsOfPaymentStore" placeholder="Select terms of payment" [disabled]="disabled"></ngx-doc-store-dropdown></td> -->
          <td>
            <ngx-doc-form-filter-select [(value)]="item.termsOfPayment" [options]="data.termsOfPaymentOptions"></ngx-doc-form-filter-select>
            <ngx-form-text [multiline]="1" [(value)]="item.termsOfPayment"></ngx-form-text>
          </td>
          <!-- <td><ngx-doc-form-texfield class="fullwidth" placeholder="Invoice" [(value)]="item.invoice" [disabled]="disabled"></ngx-doc-form-texfield></td>
          <td><ngx-doc-form-date class="fullwidth" [(value)]="$any(item).paid" [disabled]="disabled"></ngx-doc-form-date></td> -->
          <td>
            <!-- <button *ngIf="!disabled" class="nrk-doc-button" (click)="addInvoice(item); invoiceWin.open()">+</button> -->
            <button *ngIf="!disabled" class="nrk-button mb-2" [nbPopover]="deductibleSelection">☰</button>
            <ng-template #deductibleSelection>
              <div class="p-3">
                <table class="nrk-table nrk-row-select">
                  <tr><th>INV #</th><th>Payment</th><th>Issue date</th><th class="text-right">Net</th></tr>
                  <tr *ngFor="let inv of this.tree.paymentPlanInvoiceData.treeInvoices" (click)="setPaymentPlanInvoice(item, inv)">
                    <td>{{inv.doc.code}}</td>
                    <td>{{inv.payment}}</td>
                    <td>{{inv.issueDate}}</td>
                    <td class="text-right">{{inv.totalNet | currency : inv.doc.currency : 'symbol' : '1.2-2' : 'de'}}</td>
                  </tr>
                </table>
              </div>
            </ng-template>
            <button *ngIf="!disabled" class="nrk-button mb-2" [nbPopover]="paymentDateSelection">Date</button>
            <ng-template #paymentDateSelection>
              <div class="p-4">
                <h5 class="mb-3 text-center">Expected Invoice Date</h5>
                <div class="mb-3">
                  <ngx-doc-form-dropdown [(value)]="item.paymentDateRef" [options]="paymentDateOptions"></ngx-doc-form-dropdown>
                </div>
                <ng-container *ngIf="!item.paymentDateRef">
                  <ngx-doc-form-date class="fullwidth" [(value)]="$any(item).paymentDate"></ngx-doc-form-date>
                </ng-container>
                <!-- <div>{{(item.paymentDateRef ? compilation[item.paymentDateRef] : item.paymentDate) | date : 'yyyy-MM-dd' }}</div> -->
              </div>
            </ng-template>
            <ng-container *ngIf="item.paymentDate || item.paymentDateRef">
              <div style="color:gray;font-size:0.65rem">Invoice Date</div>
              <div>{{(item.paymentDateRef ? compilation[item.paymentDateRef] : item.paymentDate) | date : 'yyyy-MM-dd' }}</div>
            </ng-container>

            <div style="position:relative;right:-4rem">
              <div style="position:absolute;left:3rem;top:-3rem">
                <div *ngFor="let inv of item?.invoices" class="paymnet-invoice">
                  <!-- <button class="nrk-button" (click)="removePaymentInvoice(item, inv)">-</button> -->
                  <div *ngIf="!disabled" class="payment-invoice-remove" (click)="removePaymentInvoice(item, inv)">x</div> 
                  {{inv.code}} / {{inv.issueDate | date : 'yyyy-MM-dd' }} / {{inv.net | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </div>
              </div>
            </div>

            <!-- <nrk-window #invoiceWin>
              <nrk-header>Add Invoice</nrk-header>
              <nrk-content *ngIf="item.invoices?.length">
                <div style="height:630px">
                  <ngx-payment-plan-invoices [compilation]="compilation" [paymentPlanInvoice]="item.invoices[item.invoices.length-1]" [disabled]="disabled"></ngx-payment-plan-invoices>
                </div>
              </nrk-content>
              <nrk-footer class="text-center">
                <button class="nrk-button mr-2" (click)="invoiceWin.close()">Ok</button>
                <button class="nrk-button ml-2" (click)="item.invoices.splice(item.invoices.length-1, 1); invoiceWin.close()">Cancel</button>
              </nrk-footer>
            </nrk-window> -->
          </td>
        </tr>
        <tr>
          <td [attr.colspan]="disabled || print ? 2 : 3"></td>
          <td colspan="2" style="text-align:left"><ngx-form-text [multiline]="1" [(value)]="item.scheduleDetails" [disabled]="disabled" placeholder="Schedule Details"></ngx-form-text></td>
          <td colspan="2" *ngIf="!disabled || item.plannedValue" style="text-align:right">Planned&nbsp;Value:&nbsp;<ngx-doc-form-texfield mode="currency" format="1.2-2" [(value)]="item.plannedValue" [placeholder]="getCalculatedValue(item) + ''" [disabled]="disabled"></ngx-doc-form-texfield></td>
          <td colspan="2" *ngIf="disabled && !item.plannedValue" style="text-align:right">Calculated&nbsp;Value:&nbsp;<ngx-doc-form-texfield mode="currency" format="1.2-2" [value]="getCalculatedValue(item)" [disabled]="true"></ngx-doc-form-texfield></td>
        </tr>
      </tbody>
    </ng-container>
    <ng-container *ngIf="compilation.paymentPlan && print">
      <tbody  *ngFor="let item of compilation.paymentPlan.items; index as idx">
        <tr>
          <td style="text-align:center">{{idx + 1 | nrkPad : 2}}</td>
          <td><div>{{item.percent}}</div></td>
          <td><div [innerHTML]="sanitize((item.textPrefix?.trim() || '') + (item.scheduleDetails ? '\n' + (item.scheduleDetails?.trim() || '') : ''))"></div></td>
          <td><div [innerHTML]="sanitize(item.text)"></div></td>
          <td><div [innerHTML]="sanitize(item.termsOfPayment)"></div></td>
          <ng-container *ngIf="profitMargin">
            <td><div *ngFor="let invoice of item.invoices">{{invoice.code}}</div></td>
            <td><div *ngFor="let invoice of item.invoices">{{compilation.currency}}</div></td>
            <td><div *ngFor="let invoice of item.invoices">{{[null, 'unpaid', 'partially paid', 'paid', 'uncollectible'][invoice.paymentStatus]}}</div></td>
            <td><div *ngIf="item.paymentDate || item.paymentDateRef">{{(item.paymentDateRef ? compilation[item.paymentDateRef] : item.paymentDate) | date : 'yyyy-MM-dd'}}</div></td>
          </ng-container>
          <!-- <td><div>{{item.invoice}}</div></td>
          <td><div>{{item.paid | date : 'yyyy-MM-dd'}}</div></td> -->
        </tr>
      </tbody>
    </ng-container>
  </table>
</div>
<div *ngIf="!checkValid() && !print">
  <ngx-doc-form-textarea class="fullwidth" placeholder="Packing" [(value)]="$any(compilation).paymentPlan" [disabled]="disabled"></ngx-doc-form-textarea>
</div>
<div *ngIf="!checkValid() && print">
  <div [innerHTML]="sanitize($any(compilation).paymentPlan)"></div>
</div>
<div *ngIf="!print" style="margin-top:1rem;width:12em"><button class="nrk-button" (click)="copyToClipboard()">copy to clipboard</button></div>

